import type { ComponentType } from 'react';
import { RefinementLandingPage } from '../../../patient-files/actions/vca/refinement/RefinementLandingPage';
import { RetentionLandingPage } from '../../../patient-files/actions/vca/retention/RetentionLandingPage';
import type { ActionRunnerProps } from '../../../patient-files/actions/types';
import type { OutgoingAction } from '../../../../services/workQueue';
import type { VaWorkspaceFlow } from './vaActionItems';

type FlowRunnerProps = ActionRunnerProps & { onSubmitted?: () => void };

/** The flows that take the whole workspace; monitoring is a modal over it instead. */
export type VaFullViewFlow = Exclude<VaWorkspaceFlow, 'manage-monitoring'>;

// The same landings Manage Tx opens, unchanged.
const FLOW_RUNNERS: Record<VaFullViewFlow, ComponentType<FlowRunnerProps>> = {
    refinement: RefinementLandingPage,
    retention: RetentionLandingPage
};

// What the completion page shows once a trigger has moved the case.
const FLOW_COMPLETIONS: Record<VaFullViewFlow, OutgoingAction> = {
    refinement: {
        action: 'refinement-needed',
        label: 'Refinement triggered',
        actor: 'internal',
        direction: 'forward',
        to: 'Ref - 1. Ready for refinement'
    },
    retention: {
        action: 'retention-needed',
        label: 'Retention triggered',
        actor: 'internal',
        direction: 'forward',
        to: 'Ret - 1. Ready for retention'
    }
};

interface VaFlowViewProps {
    flow: VaFullViewFlow;
    patientId: string;
    patientName: string;
    onBack: () => void;
    /** A submitted trigger moves the case out of the VA step. */
    onSubmitted: (completed: OutgoingAction) => void;
}

export function VaFlowView({ flow, onSubmitted, ...props }: VaFlowViewProps) {
    const Runner = FLOW_RUNNERS[flow];
    return (
        <div className="flex-1 min-h-0 flex flex-col">
            <Runner {...props} onSubmitted={() => onSubmitted(FLOW_COMPLETIONS[flow])} />
        </div>
    );
}
